import React from 'react'
import IMG from "./express-js.png"
function ExpressLogo() {
  return (
    <img src={IMG} style={{width:"200px",height:"150px" }} alt='express' />
  )
}
export default ExpressLogo